import React from "react";
import { Box, Heading, Text } from "@chakra-ui/react";
import { Typewriter } from "../../Animations";

const Home = () => {
  return (
    <Box id="home">
      <Box bgGradient="linear(to-b, #8F6A99,#ffffff)" backgroundClip="text">
        <Heading
          as="h2"
          fontSize={{ base: "1.6rem", md: "2rem", lg: "2.4rem" }}
          mb="20px"
        >
          <Typewriter texts={["Hi,i’m Sharon Nyambura", "A UI/UX Designer"]} />
        </Heading>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Heading
          as="h2"
          fontSize={{ base: "2rem", md: "3rem", lg: "4.8rem" }}
          mb="20px"
        >
          I help early-stage startups design products that work.
        </Heading>
        <Text as="p">
          A Passionate UI/UX designer with experience in Figma,Webflow and
          sketch. I have done a number of projects and I have 3 years of
          experience and design high-quality digital products that your clients
          will love and let your business thrive.
        </Text>
      </Box>
    </Box>
  );
};

export default Home;
